import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { UserRegisterMailRequestBody, UserRegisterMailResponse } from "./types";

export class UserRegisterMailAPI extends BaseAPI<
  UserRegisterMailRequestBody,
  UserRegisterMailResponse
> {
  protected route = ApiRoutes.auth.register_mail;
  protected method = RequestMethod.POST;
}
